import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';

import { TsearchCategoryName } from '../../../../../utils/get-category-names';
import NoImage from '../../../no-image-placeholder';

import classes from './image-label.module.css';
import BPImage from '../../image';

const ImageLabel: FunctionComponent<{
  product: TProductListItem | TVehicleCard;
  info?: TsearchCategoryName | null;
  isVehicle?: boolean;
  altImage?: string;
}> = ({ product, isVehicle = false, altImage = '', info = {} }) => {
  const { t } = useTranslation();

  return (
    <div
      className={cx('relative', 'flex w-full', ' shrink-0', { 'flex-col': isVehicle })}
    >
      <picture
        className={cx(
          'aspect-video',
          'relative',
          'w-full',
          {
            'border-b border-neutral-30': !product.main_image,
          }
        )}
      >
        {product.main_image ? (
          <BPImage
            src={
              product.main_image ||
              `${process.env.PUBLIC_PREFIX}/img/car_placeholder.jpeg`
            }
            fill
            style={{
              objectPosition: 'center',
              objectFit: 'cover',
            }}
            fallbackSrc={`${process.env.PUBLIC_PREFIX}/img/car_placeholder.jpeg`}
            loading="lazy"
            priority={false}
            alt={
              altImage
                ? t(altImage, {
                  vehicle: `${product.car_brand ? `${product.car_brand.trim()} ` : ''
                    }${product.car_model ? `${product.car_model.trim()} ` : ''
                    }${product?.car_version ? `${product.car_version}` : ''}`,
                  id: product.id ? `${product.id}` : '',
                  subCategory: info?.subCategory
                    ? `${info?.subCategory}`
                    : '',
                })
                : `${product.part ? `${product.part} ` : ''}${product.car_brand ? `${product.car_brand} ` : ''
                }${product.car_model ? `${product.car_model} ` : ''}${product?.car_version ? `${product?.car_version} ` : ''
                }${product.id ? `${product.id}` : ''}`
            }
          />
        ) : (
          <div className={cx(classes.noImage)}>
            <NoImage variant="transparent" color="text-neutral-80" />
          </div>
        )}
      </picture>
      <div
        className={cx(
          { hidden: !isVehicle },
          { 'text-white': !isVehicle },
          { 'absolute top-0 left-0': !isVehicle },
          { 'bg-neutral-80': !isVehicle },
          'bg-opacity-75',
          'text-sm',
          'py-2',
          'px-4',
          'flex',
          'w-full',
          'items-top',
          'min-h-[64px]'
        )}
      >
        <div className={cx('text-sm w-full', 'text-left flex gap-1 flex-col')}>
          <div className={cx(classes.imageLabelText)}>
            <b className="text-base">{product.car_brand}</b>
            <span className="ml-1">{product?.car_model}</span>
            <span className="ml-1">{product?.car_version}</span>
          </div>
          {product.car_door_nr && (
            <b>
              {product.car_door_nr} {t('vehicle:doors')}
            </b>
          )}
          {product.engine_code && isVehicle && <b>{product?.engine_code}</b>}
        </div>
      </div>
    </div>
  );
};

export default ImageLabel;
